<template>
  <div class="w-full h-full fixed block top-0 left-0 bg-white opacity-75">
    <div class="spinner spinner-thick text-green-500 opacity-75 my-0 mx-auto block relative w-0 h-0 text-6xl" style="
      top: 50%;
  ">
    </div>
    <div class="relative mt-10 w-full text-center" style="top:50%">
      <slot  />
    </div>
  </div>
</template>
<script>
export default {
  components:{
  }
}
</script>
